<script lang="ts" setup>
import ConfirmAction from '~/components/modal-windows/ConfirmAction.vue'

const model = defineModel<boolean>()

defineProps<{
  title: string
}>()

const emit = defineEmits<{
  (e: 'confirmDeletion'): void
}>()
</script>

<template>
  <ConfirmAction
    v-model="model"
    button-title="Да, удалить"
    cancel-button-title="Нет, оставить"
    confirm-button-color="red"
    :title="title"
    @confirm-action="emit('confirmDeletion')"
  />
</template>
